export default "__VITE_ASSET__DocwdDQF__"